import logo from "../images/ethereum.png";

const Footer = () => {
  const links = [
    "https://within-the-crypto-world.netlify.app/",

    "https://metamask.io/",
  ];
  return (
    <>
      <div className="w-full flex md:jutify-center jutify-between items-center flex-col p-4 gradient-bg-footer">
        <div className="w-full flex sm:flex-row flex-col justify-between items-center my-4">
          <div className="flex flex-[0.5] justify-center items-center">
            <h1 className="text-white mx-2 text-lg">TransportEth</h1>
            <img src={logo} alt="logo" className="w-32" />
          </div>
          <div className="flex flex-1 justify-evenly items-center flex-wrap sm:mt-0 mt-5 w-full">
            <p className="text-white text-base text-center mx-2 cursor-ponter">
              <a href={links[0]} target="_blank">
                Market
              </a>
            </p>

            <p className="text-white text-base text-center mx-2 cursor-ponter">
              <a href={links[1]} target="_blank">
                Wallet
              </a>
            </p>
          </div>
        </div>
        {/* <div className="flex justify-center items-center flex-col mt-5">
          <p className="text-white text-sm text-center">Come join us</p>
          <p className="text-white text-sm text-center">info@email.com</p>
        </div> */}
        <div className="sm:w-[90%] w-full h-[0.25px] bg-gray-400 mt-5" />
        <div className="sm:w-[90%] w-full flex justify-between items-center mt-3">
          <p className="text-white text-sm text-center">
            transporteth.netlify.app
          </p>
          <p className="text-white text-sm text-center">All rights reserved</p>
        </div>
      </div>
    </>
  );
};

export default Footer;
